"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authenticateWithRefreshToken = exports.authenticateByToken = void 0;
var base_64_1 = require("base-64");
var utf8_1 = require("utf8");
var authenticateByToken = function (authClient, token, clientId, clientSecret) {
    var bodyFormData = new FormData();
    bodyFormData.append('grant_type', 'password');
    bodyFormData.append('username', 'token');
    bodyFormData.append('password', token);
    return authClient
        .post('/oauth/token', bodyFormData, {
        headers: {
            Authorization: 'Basic ' + (0, base_64_1.encode)((0, utf8_1.encode)(clientId + ':' + clientSecret)),
        },
    })
        .then(function (response) { return response.data; });
};
exports.authenticateByToken = authenticateByToken;
var authenticateWithRefreshToken = function (authClient, token, clientId, clientSecret) {
    var bodyFormData = new FormData();
    bodyFormData.append('grant_type', 'refresh_token');
    bodyFormData.append('refresh_token', token);
    return authClient
        .post('/oauth/token', bodyFormData, {
        headers: {
            Authorization: 'Basic ' + (0, base_64_1.encode)((0, utf8_1.encode)(clientId + ':' + clientSecret)),
        },
    })
        .then(function (response) { return response.data; });
};
exports.authenticateWithRefreshToken = authenticateWithRefreshToken;
